var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 4.66675C14.5 4.94281 14.2761 5.16675 14 5.16675H8.66667C8.3906 5.16675 8.16667 4.94281 8.16667 4.66675C8.16667 4.39068 8.3906 4.16675 8.66667 4.16675H14C14.2761 4.16675 14.5 4.39068 14.5 4.66675ZM14 10.8334H8.66667C8.3906 10.8334 8.16667 11.0573 8.16667 11.3334C8.16667 11.6095 8.3906 11.8334 8.66667 11.8334H14C14.2761 11.8334 14.5 11.6095 14.5 11.3334C14.5 11.0573 14.2761 10.8334 14 10.8334ZM6.5 5.33341C6.5 6.34448 5.67773 7.16675 4.66667 7.16675H3.33333C2.32227 7.16675 1.5 6.34448 1.5 5.33341V4.00008C1.5 2.98901 2.32227 2.16675 3.33333 2.16675H4.66667C5.67773 2.16675 6.5 2.98901 6.5 4.00008V5.33341ZM5.5 4.00008C5.5 3.54041 5.12633 3.16675 4.66667 3.16675H3.33333C2.87367 3.16675 2.5 3.54041 2.5 4.00008V5.33341C2.5 5.79308 2.87367 6.16675 3.33333 6.16675H4.66667C5.12633 6.16675 5.5 5.79308 5.5 5.33341V4.00008ZM6.5 10.6667V12.0001C6.5 13.0111 5.67773 13.8334 4.66667 13.8334H3.33333C2.32227 13.8334 1.5 13.0111 1.5 12.0001V10.6667C1.5 9.65568 2.32227 8.83341 3.33333 8.83341H4.66667C5.67773 8.83341 6.5 9.65568 6.5 10.6667ZM5.5 10.6667C5.5 10.2071 5.12633 9.83341 4.66667 9.83341H3.33333C2.87367 9.83341 2.5 10.2071 2.5 10.6667V12.0001C2.5 12.4597 2.87367 12.8334 3.33333 12.8334H4.66667C5.12633 12.8334 5.5 12.4597 5.5 12.0001V10.6667Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.7dd3c75cc75de7ab7aea1b1fbd6c3204.svg";
export { ForwardRef as ReactComponent };